<template>
  <proofreading-select-type slot="main" :novel-id="novelId" />
</template>

<script lang="ts">
import Vue from "vue";
import ProofreadingSelectType from "@/components/organisms/proofreading/ProofreadingSelectType.vue";

export default Vue.extend({
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { ProofreadingSelectType },
  props: {
    novelId: String,
  },
});
</script>
